<app-header></app-header>
<!-- loader -->
<app-user-area></app-user-area>
<router-outlet></router-outlet>
<!-- <div>IDLE_STATE: {{idleState}}, COUNTDOWN: {{countdown}}, LAST_PING: {{lastPing | date}}</div> -->
<div class="loading" *ngIf="loading$ | async">
    <mat-spinner></mat-spinner>
</div>
<!-- toast messages -->
<app-footer></app-footer>